import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';
import 'whatwg-fetch';
import './dom_polyfills';

import(/* webpackChunkName: "eventTrackers" */ './event_trackers').then(module =>
  module.eventTrackers(),
);
